import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useStyles } from './ActionsMenu.styles';
import { PopoverOrigin, PopoverPosition } from '@material-ui/core';
import { ActionMenuItem } from './ActionsMenu.types';
import TooltipOne from '../TooltipOne/TooltipOne.component';

interface ActionsMenuItemsProps {
  menuItems?: ActionMenuItem[];
  anchorEl?: null | Element | ((element: Element) => Element);
  position?: PopoverPosition | undefined;
  anchorOrigin?: PopoverOrigin | undefined;
  transformOrigin?: PopoverOrigin | undefined;
  onCloseMenu: () => void;
  onClickAnyItem?: () => void;
}

const ActionsMenuItems: React.FC<ActionsMenuItemsProps> = (props) => {
  const classes = useStyles();

  return (
    <>
      <Menu
        id="action-menu"
        className={classes.dropdownMenu}
        anchorEl={props.anchorEl}
        anchorPosition={props.position}
        anchorReference={props.position ? 'anchorPosition' : 'anchorEl'}
        getContentAnchorEl={null}
        keepMounted
        open={!!props.anchorEl || !!props.position}
        onClose={props.onCloseMenu}
        anchorOrigin={
          props.anchorOrigin ?? {
            vertical: 'bottom',
            horizontal: 'left',
          }
        }
        transformOrigin={
          props.transformOrigin ?? {
            vertical: 'top',
            horizontal: 'right',
          }
        }
      >
        {props.menuItems &&
          props.menuItems.map((item: ActionMenuItem, index: number) => {
            const menuItem = (
              <MenuItem
                disableRipple
                disabled={item.disabled}
                onClick={(event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
                  event.preventDefault();
                  event.stopPropagation();
                  if (item.onClick && !item.disabled) {
                    props.onClickAnyItem && props.onClickAnyItem();
                    item.onClick(event);
                  }
                }}
                style={item.style}
              >
                {item.icon}
                {item.text}
              </MenuItem>
            );

            return item.tooltip ? (
              <TooltipOne key={`${item.text}${index}`} title={item.tooltip} placement="top">
                <span>{menuItem}</span>
              </TooltipOne>
            ) : (
              <React.Fragment key={`${item.text}${index}`}>{menuItem}</React.Fragment>
            );
          })}
      </Menu>
    </>
  );
};

export default ActionsMenuItems;
